module.exports = __webpack_public_path__ + "static/img/icon5.99c15b01.png";